import fetch from 'isomorphic-fetch';
import get from 'lodash.get';

export const NEWS_NOW_PID = '220018';

export const MSNBC_TVE_PID = '2000762';

export const TODAY_ALL_DAY_PID = '2004490';

export function getPIDforPlayerKey(key) {
  const map = {
    NEWS_NOW: NEWS_NOW_PID,
    MSNBC_TVE: MSNBC_TVE_PID,
    TODAY_ALL_DAY: TODAY_ALL_DAY_PID,
  };
  if (map[key]) {
    return parseInt(map[key], 10);
  }
  return null;
}

// 0: show all ads, 1: show only preroll, 2: show only midrolls, 3: show no ads
const adLevel = 0;

export async function getPlaymakerById(pid) {
  return fetch(`https://api.leap.nbcsports.com/pid/NBCNews/${pid}/v4/desktop`)
    .then((res) => res.json())
    .then(({ pid: pidString, eventStatus: status, ...rest }) => ({
      ...rest,
      status,
      pid: pidString ? parseInt(pidString, 10) : null,
      isLive: status && status.toLowerCase() === 'live',
    }));
}

export async function getNewsNowPlaymaker() {
  return getPlaymakerById(NEWS_NOW_PID);
}

export const playmakerConfiguration = {
  news: {
    leapConfigUrl: 'https://api.leap.nbcsports.com/pid/NBCNews/{PID}/v4/{PLATFORM}',
  },
  msnbc: {
    leapConfigUrl: 'https://api.leap.nbcsports.com/pid/MSNBC/{PID}/v4/{PLATFORM}',
  },
  today: {
    leapConfigUrl: 'https://api.leap.nbcsports.com/pid/NBCNews/{PID}/v4/{PLATFORM}',
    csid: 'today_desktop_computer_web_livelinear',
    sfid: '7006068',
    afid: '137705821',
    metr: '1023',
    poster: 'https://sprtsecureassets.akamaized.net/operations/slates/tad_huge_logo.jpg',
    resource: '',
    cdnTokenEndpoint: 'https://tokens.playmakerservices.com',
    ignoredSCTEAdMessageTypes: ['breakStart', 'breakEnd'],
  },
};

export function getAdLevelForPID(pid, envvars = {}) {
  switch (pid) {
    case MSNBC_TVE_PID:
      return get(envvars, 'PLAYMAKER_ADLEVEL_MSNBC_TVE', adLevel);

    case NEWS_NOW_PID:
      return get(envvars, 'PLAYMAKER_ADLEVEL_NEWS_NOW', adLevel);

    case TODAY_ALL_DAY_PID:
      return get(envvars, 'PLAYMAKER_ADLEVEL_TODAY_ALL_DAY', adLevel);
    default:
      return adLevel;
  }
}
